import { render } from "./ReceivedReplay.vue?vue&type=template&id=8199004e&scoped=true"
import script from "./ReceivedReplay.vue?vue&type=script&lang=js"
export * from "./ReceivedReplay.vue?vue&type=script&lang=js"

import "./ReceivedReplay.vue?vue&type=style&index=0&id=8199004e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8199004e"]])

export default __exports__